/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from './modules/vue';
import vuetify from './plugins/vuetify';
import router from './plugins/router';
import store from "./plugins/store";
import i18n from "./plugins/i18n";
import wysiwyg from "./plugins/wysiwyg";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    vuetify,
    router,
    store,
    i18n
});
